<template>
  <CContainer fluid>
    <div class="metro-menu">
      <div 
        class="tile small bg-s3darkgrey">
        <i class="bi bi-basket"></i>
        <span>Ordenes de Compra</span>
      </div>
      <div 
        class="tile small bg-success" 
        @click="() => $router.push({ path: `${rootPath}/facturascompra` })">
        <i class="bi bi-bag-check"></i>
        <span>Facturas de Compra</span>
      </div>
      <div 
        class="tile small bg-warning" 
        @click="() => $router.push({ path: `${rootPath}/documentossoporte` })">
        <i class="bi bi-clipboard-check"></i>
        <span>Documentos Soporte</span>
      </div>
      <div 
        class="tile medium bg-primary" 
        @click="() => $router.push({ path: `${rootPath}/recepciondocumentoselectronicos` })">
        <i class="bi bi-filetype-xml"></i>
        <span>Recepci&oacute;n Documentos Electr&oacute;nicos</span>
      </div>
    </div>
  </CContainer>
</template>

<style>
  @import "../../assets/css/metro-menu.css";
</style>

<script>
  import { ref } from "vue";

  export default {
    name: "SalesMenu",
    components: {
    },
    data() {
      return {
        loading: false
      }
    },
    methods: {
    },
    setup() {
      const rootPath = ref("");

      return {
        rootPath
      }
    },
    mounted() {
      this.rootPath = this.$router.currentRoute.fullPath;

      console.log(this.rootPath);

    }
  }
</script>